<template>
  <div :id="id">
    <label v-if="inputLabel && !hiddenLabel" :class="customLabelClass">
      {{ inputLabel }}
      <span v-if="isMandatory" class="color-red">* </span>
    </label>
    <div>
      <div class="position-relative w-100 m-0" :id="idDropdown">
        <div :class="inputClass"> <!-- For selector with object as component value -->
          <div class="d-flex">
            <input
              :id="idDropdownData"
              type="text"
              :disabled="disabled"
              :value="value"
              class="form-control inputAccordionForm"
              :class="errorIndicatorHighlight + ' ' + customHeightClass"
              :placeholder="placeholderValue"
              autocomplete="my-field-name"
              @click="resetSelection"
              @input="$emit('input', $event.target.value)"
              @blur="verifyIncorrectValue()">
            </input>
            <i v-if="inputIcon" class="input-icon fs-14px" :class="inputIcon"></i>
          </div>
          <div
            class="contact-dropdown-list" :class="dropdownStyle"
            v-show="showDropdownVisible()">
            <div
              v-for="item in itemListFiltered"
              :key="item.id"
              class="contact-dropdown-item itemContact"
              @click="selectItem(item)"
              @mousedown="selectItem(item)">
              <div>
                <label class="font-weight-normal cursor">{{ item.name }}</label>
                <br/>
                <label class=" font-weight-normal cursor">{{ item.identifier }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div :id="idError" v-if="componentMandatoryErrorIndicator" class="color-red" :class="customErrorClass">
        {{ $t('errors.is_mandatory', { mandatoryValue: inputLabel.toLowerCase() }) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormContactDropdownLabelInput',
  props: {
    id: {
      type: String,
      default: undefined
    },
    customHeight: {
      type: String,
      default: 'none'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: String,
      default: ''
    },
    inputIcon: {
      type: String,
      default: ''
    },
    secondInputIcon: {
      type: String,
      default: ''
    },
    inputLabel: {
      type: String
    },
    isMandatory: {
      type: Boolean,
      default: false
    },
    labelClass: {
      type: String,
      default: ''
    },
    mandatoryErrorIndicator: {
      type: Boolean,
      default: false
    },
    placeholderValue: {
      type: String
    },
    value: {
      default: ''
    }
  },
  data () {
    return {
      componentMandatoryErrorIndicator: this.mandatoryErrorIndicator,
      customErrorClass: '',
      customLabelClass: '',
      displayError: false,
      nbItemsShown: 0,
      oldValue: '',
      randomId: Math.random().toString(36).substr(2, 10),
      timerId: '',
      showDropdown: false
    }
  },
  computed: {
    customHeightClass () {
      return this.customHeight !== 'none' ? 'h-' + this.customHeight + 'px' : 'h-25px'
    },
    dropdownStyle () {
      if (this.nbItemsShown > 2) {
        return 'h-180px'
      }
    },
    errorIndicatorHighlight () {
      if (this.componentMandatoryErrorIndicator) {
        return 'errorBorder'
      }
      return ''
    },
    idDropdown () {
      return this.id ? this.id + '-dropdown' : ('dropdownContact-' + this.randomId)
    },
    idDropdownData () {
      return this.id ? this.id + '-dropdown-data' : Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + '-dropdown-data'
    },
    idError () {
      return this.id ? this.id + '-error' : undefined
    },
    // Item list is the contacts list by default
    itemList () {
      return this.$engine.contacts.get()
    },
    itemListFiltered () {
      let listFiltered = this.itemList.filter(e => this.itemVisible(e))
      this.nbItemsShown = listFiltered.length
      return listFiltered
    }
  },
  created () {
    this.customLabelClass = this.labelClass
    window.addEventListener('click', this.handleClick)
    window.addEventListener('touchmove', this.handleClick)
  },
  beforeDestroy () {
    window.removeEventListener('click', this.handleClick)
    window.removeEventListener('touchmove', this.handleClick)
  },
  methods: {
    focusBloc () {
      clearTimeout(this.timerID)
      this.showDropdown = true
    },
    handleClick (e) {
      if (e.target.closest('#debtor-name-0')) {
        if (e.type === 'click' && (e.target.closest('.contact')) ) {
          this.hideBloc()
        } else {
          this.focusBloc()
        }
      } else {
        this.hideBloc()
      }
    },
    itemVisible (item) {
      if (!this.showDropdown) {
        return false
      }
      // else if (this.value.toLowerCase() === item.name.toLowerCase()) {
      //   return false
      // }
      return item.name.toLowerCase().includes(this.value.toLowerCase())
    },
    hideBloc () {
      let that = this
      this.timerID = setTimeout(function () {
        that.showDropdown = false
      }, 100)
    },
    resetSelection () {
      // désactivé pour l'instant
      if (this) {
        return
      }
      this.$emit('input', '')
      this.$emit('change-iban', '')
      this.$emit('change-identifier', '')
      this.$emit('change-idCompany', '')
      this.$emit('change-idProvider', '')
      this.$emit('change-contact', {})
    },
    selectItem (selectedItem) {
      this.$emit('input', selectedItem.name)
      this.$emit('change-iban', selectedItem.iban)
      this.$emit('change-identifier', selectedItem.identifier)
      this.$emit('change-idCompany', selectedItem.idCompany)
      this.$emit('change-idProvider', selectedItem.idProvider)
      this.$emit('change-zonecode', selectedItem.zoneCode)
      this.$emit('change-contact', selectedItem)
    },
    showDropdownVisible () {
      return this.showDropdown && this.itemList.some(e => this.itemVisible(e))
    },
    verifyIncorrectValue () {
      if (this.Dom7('#' + this.idDropdownData).hasClass('display-error')) {
        this.componentMandatoryErrorIndicator = this.isMandatory && (this.value === '' || (this.inputType === 'datetime' && this.value === 'Invalid date'))
        if (this.oldValue !== this.value) {
          this.displayError = false
        } else {
          this.displayError = true
        }
        this.oldValue = this.value
      } else if (this.displayError && this.oldValue === this.value) {
        this.componentMandatoryErrorIndicator = this.isMandatory && (this.oldValue === '' || (this.inputType === 'datetime' && this.oldValue === 'Invalid date'))
      } else {
        this.componentMandatoryErrorIndicator = false
        this.displayError = false
        this.oldValue = this.value
      }

      this.$emit('blur')
    }
  }
}
</script>
